// extracted by mini-css-extract-plugin
module.exports = {"hiddenBadge":"TwoDCamerasBadge_hiddenBadge__3l72K"};